import type { Routes } from '@/@types/routes';
import authRoute from './authRoute';
import contextSettingsRoutes from './contextSettingsRoutes.ts';
import dashboardRoutes from './dashboardRoutes.ts';
import hotelSetupRoutes from './hotelSetupRoutes.ts';
import othersRoute from './othersRoute.ts';

export const publicRoutes: Routes = [...authRoute];

export const protectedRoutes: Routes = [
  ...dashboardRoutes,
  ...contextSettingsRoutes,
  ...hotelSetupRoutes,
  ...othersRoute,
];
